import React from 'react';
import { Hero } from './components/Hero';
import { ProductGrid } from './components/ProductGrid';
import { Testimonials } from './components/Testimonials';
import { BrandClosing } from './components/BrandClosing';
import { Footer } from './components/Footer';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  return <div className="min-h-screen bg-brand-bg font-sans text-brand-text selection:bg-brand-accent selection:text-white" data-id="element-0">
      <Hero data-id="element-1" />

      <ProductGrid data-id="element-2" />
      <Testimonials data-id="element-3" />
      <BrandClosing data-id="element-4" />
      <Footer data-id="element-5" />
      <PurchasePopup data-id="element-6" />
    </div>;
}